import {
    ChallengeFitnessMetricType,
    ChallengeRuleType
} from '@core/api/ChallengeClient';

const metricUnits: Record<ChallengeFitnessMetricType, string> = {
    [ChallengeFitnessMetricType.PACE]: 'seconds per kilometre',
    [ChallengeFitnessMetricType.DISTANCE]: 'metres',
    [ChallengeFitnessMetricType.ACTIVITY_TIME_IN_MINUTES]: 'minutes',
    [ChallengeFitnessMetricType.STEPS]: 'steps',
    [ChallengeFitnessMetricType.CALORIES]: 'calories',
    [ChallengeFitnessMetricType.WORKOUT_CALCULATED_METRIC]: 'seconds',
    [ChallengeFitnessMetricType.REPS]: 'reps'
};

export const isRawValueRuleType = (ruleType?: ChallengeRuleType): boolean =>
    ruleType === ChallengeRuleType.ACTIVITY_RAW_VALUE;

export const challengeTargetUnit = (
    ruleType?: ChallengeRuleType,
    fitnessMetricType?: ChallengeFitnessMetricType
): string => {
    if (ruleType === ChallengeRuleType.ACTIVITY_COUNT) {
        return 'activities';
    }

    if (ruleType === ChallengeRuleType.ACTIVITY_RAW_VALUE) {
        return fitnessMetricType === undefined
            ? 'the selected metric'
            : metricUnits[fitnessMetricType];
    }

    return 'activity points';
};

export const COMPOSITE_POINTS_RULE_TYPE =
    'COMPOSITE_POINTS' as unknown as ChallengeRuleType;

export const supportsActivityFilters = (
    ruleType?: ChallengeRuleType
): boolean =>
    ruleType !== undefined && ruleType !== ChallengeRuleType.ACTIVITY_POINTS;
